import { render, staticRenderFns } from "./checkboxDialog.vue?vue&type=template&id=6cfb686d&scoped=true"
import script from "./checkboxDialog.vue?vue&type=script&lang=js"
export * from "./checkboxDialog.vue?vue&type=script&lang=js"
import style0 from "./checkboxDialog.vue?vue&type=style&index=0&id=6cfb686d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfb686d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cfb686d')) {
      api.createRecord('6cfb686d', component.options)
    } else {
      api.reload('6cfb686d', component.options)
    }
    module.hot.accept("./checkboxDialog.vue?vue&type=template&id=6cfb686d&scoped=true", function () {
      api.rerender('6cfb686d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/develop/checkboxDialog.vue"
export default component.exports